import { render, staticRenderFns } from "./CannedResponse.vue?vue&type=template&id=b6131396&scoped=true&"
import script from "./CannedResponse.vue?vue&type=script&lang=js&"
export * from "./CannedResponse.vue?vue&type=script&lang=js&"
import style0 from "./CannedResponse.vue?vue&type=style&index=0&id=b6131396&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6131396",
  null
  
)

export default component.exports